/**
 * Anvil Protocol Contract Addresses (Ethereum Mainnet)
 * Source: https://github.com/AcronymFoundation/anvil-contracts
 */

export const ANVIL_CONTRACTS = {
  // Core Protocol
  Anvil: '0xAEEAa594e7dc112D67b8547fe9767a02c15B5597',
  
  // Governance
  AnvilGovernorDelegate: '0xfe1118cE38818EA3C167929eacb6310CDc42a361',
  AnvilGovernorDelegator: '0x00e83d0698FAf01BD080A4Dd2927e6aB7C4874c9',
  AnvilTimelock: '0x4eeB7c5BB75Fc0DBEa4826BF568FD577f62cad21',
  
  // Claims & Rewards
  Claim: '0xeFd194D4Ff955E8958d132319F31D2aB9f7E29Ac',
  Reward: '0xC6a06f2D000b8CFDd392C4d6AB715a9ff1dA22dA',
  
  // Vault Management
  CollateralVault: '0x5d2725fdE4d7Aa3388DA4519ac0449Cc031d675f',
  
  // Letter of Credit (LOC)
  LetterOfCreditProxy: '0x14db9a91933aD9433E1A0dB04D08e5D9EF7c4808',
  LetterOfCreditProxyAdmin: '0x12225bB169b38EF8849DD4F5Cc466ae5996e341D',
  LetterOfCreditSingleton: '0x24573B112456d3a96c97fB460B436e8CA870e27E',
  
  // Liquidators
  PassThroughLiquidator: '0x9ae1CAA5cE6fA330fcE98315159BCD433B1342b8',
  Permit2PassThroughLiquidator: '0x8Aa57e442e4562c80FDDAD1b71ADF0BA75E2eb4C',
  UniswapLiquidator: '0x716321565e1EAbA200789E14ad92c9dA40B14589',
  
  // Oracles
  PythPriceOracle: '0xC6f3405c861Fa0dca04EC4BA59Bc189D1d56Ee05',
  
  // Collateral Pools
  TimeBasedCollateralPoolSingleton: '0xCc437a7Bb14f07de09B0F4438df007c8F64Cf29f',
  TimeBasedCollateralPoolBeacon: '0x1f00D6f7C18a8edf4f8Bb4Ead8a898aBDd9c9E14',
} as const

export type AnvilContractName = keyof typeof ANVIL_CONTRACTS

export const getContractAddress = (contractName: AnvilContractName): `0x${string}` => {
  return ANVIL_CONTRACTS[contractName] as `0x${string}`
}

// Environment-based configuration
export const CHAIN_CONFIG = {
  chainId: 1, // Ethereum mainnet
  chainName: 'Ethereum',
  rpcUrl: import.meta.env.VITE_ETHEREUM_RPC_URL || 'https://eth.llamarpc.com',
} as const

